module.exports = __webpack_public_path__ + "img/wedss1.1a7247db.jpg";